import { render, staticRenderFns } from "./WritingGuide.vue?vue&type=template&id=64c815de&"
import script from "./WritingGuide.vue?vue&type=script&lang=js&"
export * from "./WritingGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports